import React from "react";
import { bind } from "decko";
import { Link } from "react-router";
import { Table } from 'react-bootstrap';

import Config, { setConfigVariable } from "./include/Config";
import { listServers } from "./include/Server";
import LoginScreen from "./LoginScreen";
import KeybindInformation from "./KeybindInformation";
import i18next from "./include/Translations";

export default class IndexScreen extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            servers: listServers(),
            networkConfig: Config.networkConfiguration,
            activeLogin: null,
            language: Config.language,
            doPossessionTracking: Config.possessionTracking,
            displayTimeline: Config.displayTimeline,
            hlsMinEnabled: Config.hlsMinEnabled,
        };
    }

    connect (server) {
        this.setState({activeLogin: server});
    }

    disconnect (server) {
        server.logOut();
        this.setState({servers: listServers()});
    }

    @bind
    afterLogin () {
        this.setState({
            servers: listServers(),
            activeLogin: null
        })
    }

    @bind
    setPossessionTracking (doTrack) {
        this.setState({doPossessionTracking: doTrack});
        setConfigVariable("possessionTracking", doTrack);
    }

    @bind
    setLanguage (lang) {
        this.setState({language: lang});
        setConfigVariable("language", lang);
        i18next.changeLanguage(lang)
    }

    @bind
    setHlsMinEnabled (enabledHlsMin) {
        this.setState({hlsMinEnabled: enabledHlsMin});
        setConfigVariable("hlsMinEnabled", enabledHlsMin);
    }

    @bind
    setDisplayTimeline (displayTimeline) {
        this.setState({displayTimeline});
        setConfigVariable("displayTimeline", displayTimeline);
    }

    @bind
    setNetworkConfig (networkConfig) {
        const oldConfig = this.state.networkConfig;
        this.setState({networkConfig});
        setConfigVariable("networkConfiguration", networkConfig);

        if (oldConfig !== networkConfig) {
            //Refresh page
            window.location.reload();
        }
    }

    render () {

        const connectedServers = this.state.servers.filter((s) => s.accessToken !== "").map((server) => (
            <tr className="success" key={server.name}>
                <td className="text-center"><span className="glyphicon glyphicon-ok" /></td>
                <td className="text-capitalize">{server.name}</td>
                <td>{server.username}</td>
                <td>
                    <button className="btn btn-default fullwidth" onClick={() => this.disconnect(server)}>
                        DISCONNECT
                    </button>
                </td>
            </tr>
        ));

        const disconnectedServers = this.state.servers.filter((s) => s.accessToken === "").map((server) => (
            <tr className="danger" style={{verticalAlign: "bottom"}} key={server.name}>
                <td className="text-center"><span className="glyphicon glyphicon-remove" /></td>
                <td className="text-capitalize">{server.name}</td>
                <td colSpan="2">
                    <button className="btn btn-primary fullwidth" onClick={() => this.connect(server)}>
                        CONNECT
                    </button>
                </td>
            </tr>
        ));

        const languageOptions = (
            <div className="btn-group btn-group-sm">
                {["en", "no", "se", "dk"].map((lang) => (
                    <button key={lang} type="button"
                            className={"btn " + (lang === this.state.language ? "btn-primary" : "btn-default")}
                            onClick={() => {this.setLanguage(lang)}}>
                        {lang.toUpperCase()}
                    </button>
                ))}
            </div>
        );

        const statusPage = (
            <div style={{marginTop: '12px', marginBottom: '12px'}}>
                <div className="col-xs-12 text-center">
                    Troubleshooting:
                </div>
                <div>
                    <a href='http://forzify-status.s3-website-eu-west-1.amazonaws.com/'>Stream Status Page</a>
                </div>
            </div>
        );

        return (
            <div className="row text-center" style={{marginTop: "120px"}}>
                <div className="col-xs-12">
                    <h2>Forzify tagging interface</h2>
                </div>
                <div className="col-xs-12" style={{marginTop: "20px"}}>
                    {connectedServers.length !== 0 &&
                        <div className="col-xs-8 col-xs-offset-2">
                            <div className="btn-group btn-group-justified">
                                <Link to="/level1" className="btn btn-default" role="button">
                                    First-level
                                </Link>
                                <Link to="/level2" className="btn btn-default" role="button">
                                    Second-level
                                </Link>
                                <Link to="/games" className="btn btn-default" role="button">
                                    Games
                                </Link>
                            </div>
                        </div>
                    }
                    {connectedServers.length === 0 &&
                        <div className="col-xs-12" style={{color: "red"}}>
                            <h3>
                                You must connect to at least one server
                            </h3>
                        </div>
                    }
                </div>
                <div className="col-xs-12 text-center" style={{marginTop: "40px"}}>

                    {this.state.activeLogin !== null &&
                        <LoginScreen
                            key={this.state.activeLogin.name}
                            server={this.state.activeLogin}
                            onDone={this.afterLogin} />
                    }

                    <div className="col-xs-12">
                        <h3>
                            Connected servers:
                        </h3>
                    </div>
                    <div className="col-xs-8 col-xs-offset-2">
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th />
                                    <th>Server</th>
                                    <th colSpan="2">User</th>
                                </tr>
                            </thead>
                            <tbody className="text-left" style={{fontSize: "21px"}}>
                                {connectedServers}
                                {connectedServers.length > 0 && disconnectedServers.length > 0 &&
                                    <tr style={{height: "30px"}}>
                                        <td colSpan="4" />
                                    </tr>
                                }
                                {disconnectedServers}
                            </tbody>
                        </Table>
                        {this.state.servers.some( server => (server.accessToken && !server.isAdmin)) && (
                            <div className="col-xs-12 text-center" style={{color: "red", marginBottom: "20px", fontSize:"large"}}>
                                <b>Note: User does not have publishing or editing rights!</b>
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-xs-12 text-center">
                    {statusPage}
                </div>
                <div className="col-xs-12">
                    <div className="col-xs-12 text-center">
                        Network configuration:
                    </div>
                    <div className="btn-group btn-group-sm">
                        <button type="button"
                                className={"btn " + (this.state.networkConfig === "tagging" ? "btn-success" : "btn-default")}
                                onClick={() => {this.setNetworkConfig("tagging")}}>
                            Tagging Center (default)
                        </button>
                        <button type="button"
                                className={"btn " + (this.state.networkConfig === "tagging-ip" ? "btn-success" : "btn-default")}
                                onClick={() => {this.setNetworkConfig("tagging-ip")}}>
                            Tagging Center (IP fallback)
                        </button>
                        <button type="button"
                                className={"btn " + (this.state.networkConfig === "public" ? "btn-danger" : "btn-default")}
                                onClick={() => {this.setNetworkConfig("public")}}>
                            Public internet<span className="asterisk">*</span>
                        </button>
                        <button type="button"
                                className={"btn " + (this.state.networkConfig === "telenor-internal" ? "btn-danger" : "btn-default")}
                                onClick={() => {this.setNetworkConfig("telenor-internal")}}>
                            Telenor internal ( nas.norkring.net )
                        </button>
                        <button type="button"
                                className={"btn " + (this.state.networkConfig === "ssh-tunnel" ? "btn-danger" : "btn-default")}
                                onClick={() => {this.setNetworkConfig("ssh-tunnel")}}>
                            Forzasys SSH-tunnel
                        </button>
                    </div>
                    <div className="col-xs-12 text-center">
                        <small>Primarily for testing outside default Tagging Center network. If video does not load, this may be misconfigured</small>
                        <br />
                        <small><span className="asterisk">*</span> Livestreams and video still within holdback will not load over public web</small>
                    </div>
                </div>
                <div className="col-xs-12" style={{marginTop: "20px"}}>
                    <div className="col-xs-12 text-center">
                        Language:
                    </div>
                    {languageOptions}
                </div>
                <div className="col-xs-12" style={{marginTop: "20px"}}>
                    <div className="col-xs-12 text-center">
                        Possession tracking:
                    </div>
                    <div className="btn-group btn-group-sm">
                        <button type="button"
                                className={"btn " + (this.state.doPossessionTracking ? "btn-primary" : "btn-default")}
                                onClick={() => {this.setPossessionTracking(true)}}>
                            Enabled
                        </button>
                        <button type="button"
                                className={"btn " + (!this.state.doPossessionTracking ? "btn-primary" : "btn-default")}
                                onClick={() => {this.setPossessionTracking(false)}}>
                            Disabled
                        </button>
                    </div>
                </div>
                <div className="col-xs-12" style={{marginTop: "20px"}}>
                    <div className="col-xs-12 text-center">
                        Experimental compressed streaming:
                    </div>
                    <div className="btn-group btn-group-sm">
                        <button type="button"
                                className={"btn " + (this.state.hlsMinEnabled ? "btn-primary" : "btn-default")}
                                onClick={() => {this.setHlsMinEnabled(true)}}>
                            Enabled
                        </button>
                        <button type="button"
                                className={"btn " + (!this.state.hlsMinEnabled ? "btn-primary" : "btn-default")}
                                onClick={() => {this.setHlsMinEnabled(false)}}>
                            Disabled
                        </button>
                    </div>
                </div>
                <div className="col-xs-12" style={{marginTop: "20px"}}>
                    <div className="col-xs-12 text-center">
                        Event timeline:
                    </div>
                    <div className="btn-group btn-group-sm">
                        <button type="button"
                                className={"btn " + (this.state.displayTimeline ? "btn-primary" : "btn-default")}
                                onClick={() => {this.setDisplayTimeline(true)}}>
                            Enabled
                        </button>
                        <button type="button"
                                className={"btn " + (!this.state.displayTimeline ? "btn-primary" : "btn-default")}
                                onClick={() => {this.setDisplayTimeline(false)}}>
                            Disabled
                        </button>
                    </div>
                </div>
                <div className="col-xs-8 col-xs-offset-2" style={{marginTop: "20px"}}>
                    <KeybindInformation />
                </div>
                <div className="col-xs-12 text-center" style={{marginTop: "20px"}}>
                    <small>
                        <i>Version: {Config.buildVersion}</i>
                    </small>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/IndexScreen.js